import queryString from 'query-string';
import {
  AddTipParams,
  IAddStaffSaleBody,
  IAdjustTip,
  IApiChangeServiceBody,
  IApiDeleteMultipleTicketBody,
  IApiGetTicketsParam,
  IApiModifyTipCashBody,
  IApiReportCreditCard,
  IApiSummaryPaymentTypeParam,
  IApiUpdateSupplyFeeBody,
  IDeleteMultipleRevokedTicketBody,
  IEditStaffByBillId,
  IParamSummaryCreditCards,
  IPartialVoidPayload,
  IPayloadAptConfirm,
  IRefundBody,
  IRevokedBatchBody,
  IUnrevokeTicketBody,
  IUpdateSaleVoidTicketPayload,
  VoidByBillIdParams,
} from './types/api';
import fetch from 'services/request';
import { IAddTicketManualBody, IApiSplitMasterPayload, IApiSplitTicketItem } from './types/ticket';

const baseURL = 'api/v1';

export const getTicketsData = (params: IApiGetTicketsParam) => {
  const paramsPasser = queryString.stringify(
    { ...params },
    { arrayFormat: 'bracket' }
  );

  return fetch({
    method: 'get',
    url: `${baseURL}/bill/list-ticket-by-status?${paramsPasser?.replaceAll('[]', '')}`,
  });
};

export const getTicketDetailsData = (id: string) => {
  return fetch({
    method: 'get',
    url: `${baseURL}/bill/transaction-detail-v2/${id}`,
  });
};

export const changeStaffByBillId = (payload: IEditStaffByBillId) => {
  const _body = {
    billId: payload.billId,
    staffIdOld: payload.staffIdOld,
    staffIdNew: payload.staffIdNew,
  };

  return fetch({
    method: 'post',
    url: `${baseURL}/payment/edit-ticket-staff`,
    body: _body,
    pinCode: payload.pinCode,
  });
};
export const refundByBillId = (payload: IRefundBody) => {
  const _body = {
    billId: payload.billId,
    amount: payload.amount,
    staffId: payload.staffId,
    reason: payload.reason,
  };
  return fetch({
    method: 'post',
    url: `${baseURL}/payment/refund-ticket`,
    body: _body,
    pinCode: payload.pinCode,
  });
};

export const voidByBillId = ({ id, reason, staffId }: VoidByBillIdParams) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/payment/void-ticket`,
    body: { billId: id, reason, staffId }
  });
};

export const addTipByBillId = (body: AddTipParams) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/payment/add-tip-credit-card`,
    body,
  });
};

export const editCashByBillId = (body: IRefundBody) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/payment/edit-cash`,
    body,
  });
};
export const adjustTip = (body: IAdjustTip[]) => {
  return fetch({
    method: 'post',
    url: `${baseURL}/payment/adjust-multiple-tip-card`,
    body,
  });
};
const updateTicketClosed = (body: IPayloadAptConfirm) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/update-ticket-closed',
    body,
    autoToast: true,
  });
};

const removePendingTicket = (billId: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/bill/delete-ticket/${billId}`,
    autoToast: true,
  });
};

const deleteClosedTicket = (billId: string, reason: string, staffId: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/delete-closed-ticket',
    autoToast: true,
    body: { billId, reason, staffId },
  });
};

const getSummaryCreditCards = (params: IParamSummaryCreditCards) => {
  return fetch({
    method: 'get',
    url: '/api/v1/bill/summary-credit-cards',
    params,
  });
};

const modifyTipCash = (body: IApiModifyTipCashBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/payment/modify-tip-cash',
    body,
  });
};

const splitCloseTicket = (billId: string, body: IApiSplitTicketItem[]) => {
  return fetch({
    method: 'post',
    url: `/api/v1/bill/split-close-ticket/${billId}`,
    body,
  });
};

const addTicketManual = (body: IAddTicketManualBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/add-ticket-manual',
    body,
  });
};

const getSummaryTickets = (params: IApiGetTicketsParam) => {
  const paramsPasser = queryString.stringify(
    { ...params },
    { arrayFormat: 'bracket' }
  );

  return fetch({
    method: 'get',
    url: `/api/v1/bill/summary-tickets?${paramsPasser?.replaceAll('[]', '')}`,
  });
};

const updateSupplyFee = (body: IApiUpdateSupplyFeeBody) => fetch({
  method: 'post',
  url: '/api/v1/bill/update-supply-fee',
  body,
});


const changeService = (body: IApiChangeServiceBody) => fetch({
  method: 'post',
  url: '/api/v1/bill/update-service-name-item',
  body,
});

const deletemMultipleTicket = (body: IApiDeleteMultipleTicketBody) => fetch({
  method: 'post',
  url: '/api/v1/bill/delete-multiple-closed-ticket',
  body,
});

const updateCustomerClosedTicket = (billId: string, customerId: string) => fetch({
  method: 'post',
  url: '/api/v1/bill/update-customer-closed-ticket',
  body: { billId, customerId },
});

export const getReportCreditCards = (params: IApiReportCreditCard) => {
  const paramsPasser = queryString.stringify(
    { ...params },
    { arrayFormat: 'bracket' }
  );
  
  return fetch({
    method: 'get',
    url: `${baseURL}/report/credit-cards?${paramsPasser?.replaceAll('[]', '')}`,
  });
};

const unrevokeTicket = (body: IUnrevokeTicketBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/un-revoked',
    body,
  });
};

const getSummaryPaymentType = (params: IApiSummaryPaymentTypeParam) => {
  return fetch({
    method: 'get',
    url: '/api/v1/bill/summary-payment-type',
    params,
  });
};

const addSaleStaff = (body: IAddStaffSaleBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/payment/add-sale-staff',
    body,
  });
};

const getDejavooDailyReport = (date: string, stationNumber: string) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/dejavoo-daily-report',
    params: { date, stationNumber },
  });
};

const getDejavooDailySummary = (date: string) => {
  return fetch({
    method: 'get',
    url: '/api/v1/report/dejavoo-daily-summary',
    params: { date },
  });
};

const partialVoidTicket = (body: IPartialVoidPayload) => {
  return fetch({
    method: 'post',
    url: '/api/v1/payment/partial-void-ticket',
    body,
  });
};

const updateSaleVoidTicket = (body: IUpdateSaleVoidTicketPayload[]) => {
  return fetch({
    method: 'post',
    url: '/api/v1/payment/update-sale-void-ticket',
    body,
  });
};

const revokedBatch = (body: IRevokedBatchBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/revoked-batch',
    body,
  });
};

const deleteBatch = (body: IRevokedBatchBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/delete-batch',
    body,
  });
};

const deleteMultipleRevokedTicket = (body: IDeleteMultipleRevokedTicketBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/delete-revoked',
    body,
  });
};

const getSummaryRevokedCash = (params: IApiSummaryPaymentTypeParam) => {
  return fetch({
    method: 'get',
    url: '/api/v1/bill/summary-revoked-cash',
    params,
  });
};

const resendSMSReview = (billId: string) => {
  return fetch({
    method: 'post',
    url: `/api/v1/review/resend-sms-review/${billId}`,
  });
};

const splitMasterTicket = (body: IApiSplitMasterPayload) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/split-master',
    body,
  });
};

const ticketListApis = {
  getTicketsData,
  getTicketDetailsData,
  refundByBillId,
  voidByBillId,
  changeStaffByBillId,
  editCashByBillId,
  adjustTip,
  updateTicketClosed,
  removePendingTicket,
  deleteClosedTicket,
  getSummaryCreditCards,
  modifyTipCash,
  splitCloseTicket,
  addTicketManual,
  getSummaryTickets,
  updateSupplyFee,
  changeService,
  deletemMultipleTicket,
  updateCustomerClosedTicket,
  getReportCreditCards,
  unrevokeTicket,
  getSummaryPaymentType,
  addSaleStaff,
  getDejavooDailyReport,
  getDejavooDailySummary,
  partialVoidTicket,
  updateSaleVoidTicket,
  revokedBatch,
  deleteBatch,
  deleteMultipleRevokedTicket,
  getSummaryRevokedCash,
  resendSMSReview,
  splitMasterTicket,
};

export default ticketListApis;
